module.exports = __webpack_public_path__ + "media/components/page-header/static/tide-badge--dark-76f283cfa6c70613fbca0b90ed257ad0.svg";